module.exports = __webpack_public_path__ + "img/1440855202.b6397c5e.jpg";